import React, { useEffect } from 'react';
import { NavLink, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './AdminPage.css';

interface NavItem {
  to: string;
  icon: string;
  label: string;
  soon?: boolean;
}

const NAV: NavItem[] = [
  { to: '/admin/tutorials', icon: '🎬', label: 'Tutorials' },
  { to: '/admin/screeners', icon: '📊', label: 'Screeners' },
  { to: '/admin/plans',     icon: '💳', label: 'Plans' },
  { to: '/admin/users',     icon: '👥', label: 'Users' },
  { to: '/admin/chat',          icon: '💬', label: 'Chat' },
  { to: '/admin/announcements', icon: '📢', label: 'Updates' },
];

const AdminPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.userType === 'SYSTEM';

  useEffect(() => {
    if (user !== undefined && !isAdmin) navigate('/');
  }, [user, isAdmin, navigate]);

  if (!isAdmin) return null;

  return (
    <div className="adm-shell">
      {/* Sub-nav */}
      <aside className="adm-nav">
        <div className="adm-nav-label">Admin Panel</div>
        {NAV.map(({ to, icon, label, soon }) => (
          soon ? (
            <div key={to} className="adm-nav-item adm-nav-item--soon">
              <span className="adm-nav-icon">{icon}</span>
              <span className="adm-nav-text">{label}</span>
              <span className="adm-nav-badge">Soon</span>
            </div>
          ) : (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `adm-nav-item${isActive ? ' adm-nav-item--active' : ''}`
              }
            >
              <span className="adm-nav-icon">{icon}</span>
              <span className="adm-nav-text">{label}</span>
            </NavLink>
          )
        ))}
      </aside>

      {/* Section content */}
      <div className="adm-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminPage;
